import "../styles/TableHeader.css";

function TableHeader() {
  return (
    <div className="table__header">
      <div className="table__left-container">
        <h4>Actions</h4>
        <p className="table__lower-text">Move, Indent, Outdent, Delete</p>
      </div>

      <div className="table__right-container">
        <h4>ToDo(s)</h4>
        <p className="table__lower-text">The text for todos</p>
      </div>
    </div>
  );
}

export default TableHeader;
